import { useEffect, useState } from 'react';
import AdminLayout from '@/components/feature/AdminLayout';
import { supabase } from '@/lib/supabase';
import LoginForm from './components/LoginForm';
import Mailbox from './components/Mailbox';

export default function AdminSupport() {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setAuthed(!!data.session);
      setChecking(false);
    });
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setAuthed(!!session);
    });
    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setAuthed(false);
  };

  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto">
        {checking ? (
          <div className="py-20 text-center text-foreground-600">Đang tải...</div>
        ) : authed ? (
          <Mailbox onLogout={handleLogout} />
        ) : (
          <LoginForm onSuccess={() => setAuthed(true)} />
        )}
      </div>
    </AdminLayout>
  );
}